export default __webpack_public_path__ + "static/media/fridge-freezer.9e644b15.svg";